// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Apollo.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Apollo-lotus-fire.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Apollo-full.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Apollo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: block;
  /* Exclude U+F1DD — main Apollo maps it to a filter/star, not the Lotus flame */
  unicode-range: U+0000-F1DC, U+F1DE-10FFFF;
}

/* Lotus Apollo — selective glyphs only (do not replace full Apollo font)
   Used for: icon-fire (\\f1dd), icon-my-markets-solid favorite star (\\f195) */
@font-face {
  font-family: ApolloLotusFire;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: block;
}

/* Full Apollo font for glyphs missing or wrong in the subset (arrows, footer, etc.) */
@font-face {
  font-family: ApolloLotusFull;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: block;
}

.icon::before,
[class^="icon-"]::before,
[class*=" icon-"]::before {
  font-family: Apollo !important;
  font-style: normal;
  font-weight: 400 !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-sports-home::before {
  content: "\\f12c";
}

.icon-sports-home-solid::before {
  content: "\\f12d";
}

.icon-footer-sport::before {
  content: "\\f1d3";
}

.icon-footer-casino::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1d9";
}

/* Lotus mobile bottom-nav — Open Bets / Profile (scraped U+F1D8 / U+F1D7) */
.icon-footer-open-bets::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1d8";
}

.icon-footer-profile::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1d7";
}

.icon-burger::before {
  font-family: ApolloLotusFull !important;
  content: "\\f217";
}

.icon-bell::before {
  content: "\\f221";
}

.icon-search-new::before {
  content: "\\f158";
}

.icon-wallet-solid::before {
  content: "\\f107";
}

.icon-profile-solid::before {
  content: "\\f174";
}

.icon-arrow-down-new::before {
  content: "\\f22e";
}

.icon-settings::before {
  content: "\\f154";
}

.icon-sign-out::before {
  content: "\\f14d";
}

.icon-change-password::before {
  content: "\\f20f";
}

.icon-account-statement::before {
  content: "\\f23e";
}

.icon-transfer-statement-solid::before {
  content: "\\f116";
}

.icon-rules::before {
  content: "\\f15e";
}

.icon-profit-loss::before {
  content: "\\f17c";
}

.icon-my-bets::before {
  content: "\\f195";
}

/* Lotus favorite star — our Apollo maps \\f195 to a ticket; Lotus font has the star */
.icon-my-markets-solid::before {
  font-family: ApolloLotusFire !important;
  content: "\\f195";
}

.icon-kyc::before {
  content: "\\f1af";
}

.icon-responsible-gambling::before {
  content: "\\f167";
}

.icon-exclusion-policy::before {
  content: "\\f1e9";
}

.icon-exchange-games::before {
  content: "\\f1eb";
}

.icon-sport-cricket::before {
  content: "\\f140";
}

.icon-sport-football::before {
  content: "\\f13b";
}

.icon-sport-tennis::before {
  content: "\\f12f";
}

.icon-sport-americanfootball::before {
  content: "\\f144";
}

.icon-sport-rugbyleague::before {
  content: "\\f132";
}

.icon-sport-basketball::before {
  content: "\\f142";
}

.icon-sport-golf::before {
  content: "\\f13a";
}

.icon-sport-horseracing::before {
  content: "\\f137";
}

.icon-sport-greyhoundracing::before {
  content: "\\f139";
}

.icon-sport-baseball::before {
  content: "\\f143";
}

.icon-sport-boxing::before {
  content: "\\f141";
}

.icon-sport-mixedmartialarts::before {
  content: "\\f135";
}

.icon-virtual-sports::before {
  content: "\\f109";
}

.icon-popular-new::before {
  content: "\\f177";
}

.icon-fire::before {
  /* Must use Lotus fire subset — main Apollo.woff2 maps \\f1dd to a star/filter */
  font-family: ApolloLotusFire, ApolloLotusFull !important;
  content: "\\f1dd";
}

.icon-fire2::before {
  content: "\\f1dc";
}

.icon-live-bg::before {
  content: "\\f1a9";
}

.icon-live-new::before {
  content: "\\f1a8";
}

.icon-gamcare::before {
  content: "\\f1d3";
}

.icon-age-limit-updated::before {
  content: "\\f23d";
}

.icon-restricted-territories::before {
  content: "\\f167";
}

.icon-navigate-to-link::before {
  content: "\\f194";
}

.icon-recommended-new::before {
  content: "\\f16e";
}

.icon-filter::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1df";
}

.icon-search-lite::before {
  font-family: ApolloLotusFull !important;
  content: "\\f158";
}

.icon-cross::before {
  font-family: ApolloLotusFull !important;
  content: "\\f200";
}

.icon-video::before {
  content: "\\f10d";
}

.icon-angle-right::before {
  font-family: ApolloLotusFull !important;
  content: "\\f235";
}

.icon-angle-left::before {
  font-family: ApolloLotusFull !important;
  content: "\\f236";
}

.icon-angle-up::before {
  font-family: ApolloLotusFull !important;
  content: "\\f232";
}

.icon-angle-down::before {
  font-family: ApolloLotusFull !important;
  content: "\\f233";
}

.icon-heart::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1c8";
}

/* Place-bet virtual keyboard */
.icon-hide-keyboard::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1c7";
}

.icon-clear::before {
  font-family: ApolloLotusFull !important;
  content: "\\f20c";
}

.icon-rounded-arrow-up::before {
  font-family: ApolloLotusFull !important;
  content: "\\f162";
}

.icon-play-second::before {
  content: "\\f183";
}

.icon-market-play::before {
  font-family: ApolloLotusFull !important;
  content: "\\f19d";
}

.icon-forbidden::before {
  font-family: ApolloLotusFull !important;
  content: "\\f1d4";
}
`, "",{"version":3,"sources":["webpack://./src/apollo-icons.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4DAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+EAA+E;EAC/E,yCAAyC;AAC3C;;AAEA;6EAC6E;AAC7E;EACE,4BAA4B;EAC5B,4DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sFAAsF;AACtF;EACE,4BAA4B;EAC5B,+DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+EAA+E;EAC/E,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: Apollo;\n  src: url(\"./assets/fonts/Apollo.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: block;\n  /* Exclude U+F1DD — main Apollo maps it to a filter/star, not the Lotus flame */\n  unicode-range: U+0000-F1DC, U+F1DE-10FFFF;\n}\n\n/* Lotus Apollo — selective glyphs only (do not replace full Apollo font)\n   Used for: icon-fire (\\f1dd), icon-my-markets-solid favorite star (\\f195) */\n@font-face {\n  font-family: ApolloLotusFire;\n  src: url(\"./assets/fonts/Apollo-lotus-fire.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: block;\n}\n\n/* Full Apollo font for glyphs missing or wrong in the subset (arrows, footer, etc.) */\n@font-face {\n  font-family: ApolloLotusFull;\n  src: url(\"./assets/fonts/Apollo-full.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: block;\n}\n\n.icon::before,\n[class^=\"icon-\"]::before,\n[class*=\" icon-\"]::before {\n  font-family: Apollo !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-sports-home::before {\n  content: \"\\f12c\";\n}\n\n.icon-sports-home-solid::before {\n  content: \"\\f12d\";\n}\n\n.icon-footer-sport::before {\n  content: \"\\f1d3\";\n}\n\n.icon-footer-casino::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1d9\";\n}\n\n/* Lotus mobile bottom-nav — Open Bets / Profile (scraped U+F1D8 / U+F1D7) */\n.icon-footer-open-bets::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1d8\";\n}\n\n.icon-footer-profile::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1d7\";\n}\n\n.icon-burger::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f217\";\n}\n\n.icon-bell::before {\n  content: \"\\f221\";\n}\n\n.icon-search-new::before {\n  content: \"\\f158\";\n}\n\n.icon-wallet-solid::before {\n  content: \"\\f107\";\n}\n\n.icon-profile-solid::before {\n  content: \"\\f174\";\n}\n\n.icon-arrow-down-new::before {\n  content: \"\\f22e\";\n}\n\n.icon-settings::before {\n  content: \"\\f154\";\n}\n\n.icon-sign-out::before {\n  content: \"\\f14d\";\n}\n\n.icon-change-password::before {\n  content: \"\\f20f\";\n}\n\n.icon-account-statement::before {\n  content: \"\\f23e\";\n}\n\n.icon-transfer-statement-solid::before {\n  content: \"\\f116\";\n}\n\n.icon-rules::before {\n  content: \"\\f15e\";\n}\n\n.icon-profit-loss::before {\n  content: \"\\f17c\";\n}\n\n.icon-my-bets::before {\n  content: \"\\f195\";\n}\n\n/* Lotus favorite star — our Apollo maps \\f195 to a ticket; Lotus font has the star */\n.icon-my-markets-solid::before {\n  font-family: ApolloLotusFire !important;\n  content: \"\\f195\";\n}\n\n.icon-kyc::before {\n  content: \"\\f1af\";\n}\n\n.icon-responsible-gambling::before {\n  content: \"\\f167\";\n}\n\n.icon-exclusion-policy::before {\n  content: \"\\f1e9\";\n}\n\n.icon-exchange-games::before {\n  content: \"\\f1eb\";\n}\n\n.icon-sport-cricket::before {\n  content: \"\\f140\";\n}\n\n.icon-sport-football::before {\n  content: \"\\f13b\";\n}\n\n.icon-sport-tennis::before {\n  content: \"\\f12f\";\n}\n\n.icon-sport-americanfootball::before {\n  content: \"\\f144\";\n}\n\n.icon-sport-rugbyleague::before {\n  content: \"\\f132\";\n}\n\n.icon-sport-basketball::before {\n  content: \"\\f142\";\n}\n\n.icon-sport-golf::before {\n  content: \"\\f13a\";\n}\n\n.icon-sport-horseracing::before {\n  content: \"\\f137\";\n}\n\n.icon-sport-greyhoundracing::before {\n  content: \"\\f139\";\n}\n\n.icon-sport-baseball::before {\n  content: \"\\f143\";\n}\n\n.icon-sport-boxing::before {\n  content: \"\\f141\";\n}\n\n.icon-sport-mixedmartialarts::before {\n  content: \"\\f135\";\n}\n\n.icon-virtual-sports::before {\n  content: \"\\f109\";\n}\n\n.icon-popular-new::before {\n  content: \"\\f177\";\n}\n\n.icon-fire::before {\n  /* Must use Lotus fire subset — main Apollo.woff2 maps \\f1dd to a star/filter */\n  font-family: ApolloLotusFire, ApolloLotusFull !important;\n  content: \"\\f1dd\";\n}\n\n.icon-fire2::before {\n  content: \"\\f1dc\";\n}\n\n.icon-live-bg::before {\n  content: \"\\f1a9\";\n}\n\n.icon-live-new::before {\n  content: \"\\f1a8\";\n}\n\n.icon-gamcare::before {\n  content: \"\\f1d3\";\n}\n\n.icon-age-limit-updated::before {\n  content: \"\\f23d\";\n}\n\n.icon-restricted-territories::before {\n  content: \"\\f167\";\n}\n\n.icon-navigate-to-link::before {\n  content: \"\\f194\";\n}\n\n.icon-recommended-new::before {\n  content: \"\\f16e\";\n}\n\n.icon-filter::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1df\";\n}\n\n.icon-search-lite::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f158\";\n}\n\n.icon-cross::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f200\";\n}\n\n.icon-video::before {\n  content: \"\\f10d\";\n}\n\n.icon-angle-right::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f235\";\n}\n\n.icon-angle-left::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f236\";\n}\n\n.icon-angle-up::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f232\";\n}\n\n.icon-angle-down::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f233\";\n}\n\n.icon-heart::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1c8\";\n}\n\n/* Place-bet virtual keyboard */\n.icon-hide-keyboard::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1c7\";\n}\n\n.icon-clear::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f20c\";\n}\n\n.icon-rounded-arrow-up::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f162\";\n}\n\n.icon-play-second::before {\n  content: \"\\f183\";\n}\n\n.icon-market-play::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f19d\";\n}\n\n.icon-forbidden::before {\n  font-family: ApolloLotusFull !important;\n  content: \"\\f1d4\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
